import { ApiProvider } from "@/providers/api-provider";

class DocumentTypeApiProvider extends ApiProvider {
    async getAllDocumentTypes(): Promise<any> {
        const response = await this.get('/document-types');
        return response.data;
    }
}

export const documentTypeApiProvider = new DocumentTypeApiProvider();
